import { useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import Layout2 from './components/Layout/Layout2'; // Assuming Layout2 is used for the homepage layout
import Home from './components/Pages/Home'; // Assuming Home is your homepage component

function App() {
  const { pathname } = useLocation();

  // Ensure the page scrolls to the top when navigating
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <Routes>
      {/* Simplified routing to serve only the homepage */}
      <Route path="/" element={<Layout2 darkMode />}>
        <Route index element={<Home />} />
      </Route>
    </Routes>
  );
}

export default App;
